import { Component, Input } from '@angular/core';
import { WeatherIcon } from 'ngx-core-services';

@Component({
  selector: 'lib-weather-icon',
  templateUrl: './weather-icon.component.html',
  styleUrls: ['./weather-icon.component.scss'],
})
export class WeatherIconComponent {
  @Input() icon: WeatherIcon = 'sun-shower';
}
